import { render, staticRenderFns } from "./FlowConfig.vue?vue&type=template&id=5a31f980&scoped=true&"
import script from "./FlowConfig.vue?vue&type=script&lang=js&"
export * from "./FlowConfig.vue?vue&type=script&lang=js&"
import style0 from "./FlowConfig.vue?vue&type=style&index=0&id=5a31f980&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a31f980",
  null
  
)

export default component.exports